import React from "react";

function Empty(props:{empty_label: string}) {
  return <span className="emptyMessage">{props.empty_label}</span>;
}

export default Empty;
